<div class="register-number-outer-container">
      <div class="info-container" style="max-width:600px;">
        <div class="headings-container">
          <div class="heading">
            <adp-label *ngIf="isTablet" labelKey="RegisterTablet_QRCode_Heading"></adp-label>
            <adp-label *ngIf="isSmartwatch" labelKey="RegisterSmartwatch_QRCode_Heading"></adp-label>
          </div>
        </div>
        <div modal-body class="input-container">
         <!-- Place QR code here -->
            <qrcode [qrdata]="value"
                 [width]="250"
                 [elementType]="elementType"
                 [errorCorrectionLevel]="correctionLevel"
                 alt="QR Code"
                 cssClass="bshadow">
            </qrcode>
        </div>

        <div style="margin-top:35px;">
          <adp-label *ngIf="isTablet" style="color:#3D515A;font-weight:600;" labelKey="RegisterCellularDevice_QRCode_Tablet_Link_Alt_Text"></adp-label>
          <adp-label *ngIf="isSmartwatch" style="color:#3D515A;font-weight:600;" labelKey="RegisterCellularDevice_QRCode_Smartwatch_Link_Alt_Text"></adp-label>
          <br><button class='link' (click)='copyToClipboard()'><adp-label labelKey="RegisterCellularDevice_QRCode_Link_Text"></adp-label></button>
          <adp-label labelKey="RegisterCellularDevice_QRCode_Link_Alt_Subtext"></adp-label>
        </div>
        <div>
          <div class="disclaimer-container" [ngClass]="!isDesktopView ? 'disclaimer-container-mobile':''">
            <p style="font-weight:600;"><adp-label labelKey="RegisterCellularDevice_QRCode_NextSteps_Header"></adp-label></p>
            <p *ngIf="isTablet"><adp-label labelKey="RegisterCellularDevice_QRCode_NextSteps_Tablet"></adp-label></p>
            <p *ngIf="isSmartwatch"><adp-label labelKey="RegisterCellularDevice_QRCode_NextSteps_Smartwatch"></adp-label></p>
            <p><adp-label labelKey="RegisterCellularDevice_QRCode_NextSteps_Subtext"></adp-label></p>
          </div>
        </div>
        <div  *ngIf="isAdditionalDeviceFlow" modal-footer fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="24px" fxLayoutGap.lt-sm="12px" class="mt-3 button-container" style="margin-top:10px;min-width:60%;">
          <button mat-flat-button class="button-add-another-device" color="accent" (click)="addAnotherDevice()"><adp-label labelKey="Global_Button_Additional_Device"></adp-label></button>
        </div>
      </div>
</div>
